import Box from "@mui/material/Box";
import { Outlet } from "@tanstack/react-router";

import MarketingFooter from "./MarketingFooter";
import MarketingHeader from "./MarketingHeader";
import MarketingShell from "./MarketingShell";
import { BAR_ROW, BAR_RULE } from "./header/tokens";
import { WIDE } from "./tokens";
import { useNotFoundBelow } from "./useNotFoundBelow";

/**
 * The chrome every public marketing surface with a fixed bar shares.
 *
 * The header and footer live here rather than in `MarketingShell` so the shell
 * stays what its name says, the theme, and the chrome can be mounted per
 * surface: the country pages carry their own clearance and the academy has no
 * footer at all. A page below that is not found is drawn without them, as the
 * published 404 is.
 */
export default function MarketingLayout() {
  if (useNotFoundBelow()) {
    return (
      <MarketingShell>
        <Outlet />
      </MarketingShell>
    );
  }
  return (
    <MarketingShell>
      <MarketingHeader />
      {/* The bar is fixed, so the page clears it in flow. */}
      <Box
        sx={{
          pt: `${BAR_ROW.mobile + BAR_RULE}px`,
          [WIDE]: { pt: `${BAR_ROW.desktop + BAR_RULE}px` },
        }}
      >
        <Outlet />
      </Box>
      <MarketingFooter />
    </MarketingShell>
  );
}
